import React, {Component} from 'react';
import { Toggle } from '@carbon/react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

class DevicePropertyToggle extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleToggle = this.handleToggle.bind(this);

		this.labelA = props.labelA;
		this.labelB = props.labelB;
	}

	render() {
	  	return <Toggle id={"device-property-toggle-" + this.propId} labelText={this.labelText} labelA={this.labelA} labelB={this.labelB}
						toggled={this.state.value != 0}
						disabled={this.state.disabled}
	  					onToggle={this.handleToggle} />

	}

	handleToggle(on) {
		var newValue = on ? 1 : 0;
		this.setState({value: newValue});
		midi.setDeviceProperty(this.propId, [newValue]);
	}

	handleControlChange(ccNum, ccValue) {
		this.setState({value: (ccValue >= 64 ? 1 : 0)});
	}

	setValue(x) {
		this.setState({value: x});
	}
}

export default DevicePropertyToggle;
